import React from "react"
import PropTypes from "prop-types"
import { Link } from "@reach/router"
import { withTheme } from "styled-components"
import { Theme } from "./theme"

export interface NavLinkProps {
  fg?: string
  theme: Theme
  [rest: string]: any
}

const NavLink = ({ fg = "black", theme, ...props }: NavLinkProps) => {
  return (
    <Link
      {...props}
      getProps={({ isPartiallyCurrent }) => {
        return {
          style: {
            color: isPartiallyCurrent ? theme.colors[fg] : null
          }
        }
      }}
    />
  )
}

NavLink.propTypes = {
  fg: PropTypes.string,
  theme: PropTypes.object.isRequired
}

export default withTheme(NavLink)
